module.exports = __webpack_public_path__ + "static/melfs_minute_meteors-4e8518026586e103224870673adc25db.png";